// Mirrors CHANGE_OPTIONS / PCT_OPTIONS in ka-creatives-skill generate_batch_report.py
export const CHANGE_OPTIONS: { key: string; label: string }[] = [
  { key: 'sfx', label: '音效' },
  { key: 'bgm', label: 'BGM' },
  { key: 'subtitle', label: '字幕' },
  { key: 'sales_text', label: '卖点花字' },
  { key: 'app_overlay', label: 'app 贴图' },
  { key: 'bug_cover', label: '视频 bug 遮盖' },
  { key: 'pacing', label: '节奏调整' },
  { key: 'tail_card', label: '尾贴修改' },
  { key: 'product_info', label: '产品信息植入' },
  { key: 'multi_version_mix', label: '多版本混剪' },
  { key: 'other', label: '其他' },
]

export const CHANGE_LABEL: Record<string, string> = Object.fromEntries(
  CHANGE_OPTIONS.map((o) => [o.key, o.label])
)

export const PCT_OPTIONS = [0, 10, 20, 30, 40, 50]

// Country folder -> product display label (mirrors COUNTRY_LABEL in
// ka-creatives-skill generate_batch_report.py)
export const COUNTRY_LABELS: Record<string, string> = {
  mib_th: '🇹🇭 Thailand',
  mib_ug: '🇺🇬 Uganda',
  mib_zm: '🇿🇲 Zambia',
  mib_pk: '🇵🇰 Pakistan',
  mib_sc: 'SookCash',
}

export function countryLabel(country: string): string {
  return COUNTRY_LABELS[country] ?? country
}

export function formatBytes(bytes: number | null): string {
  if (!bytes) return ''
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(2)} GB`
  if (bytes >= 1e6) return `${(bytes / 1e6).toFixed(1)} MB`
  return `${(bytes / 1e3).toFixed(0)} KB`
}
